import React, { useState } from 'react';
import Navbar from '../../components/Navbar';

export default function Payment() {
  const [txId, setTxId] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (txId.trim()) {
      setSubmitted(true);
    }
  };

  return (
    <div className="pi">
      <Navbar />

      <div className="sec-wrapper" style={{ maxWidth: '850px' }}>
        <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
          <span className="badge-light">✦ Registration Fee Verification ✦</span>
          <h1 className="section-title">Marriage Registration Payment</h1>
          <p style={{ color: '#6E615E', maxWidth: '650px', margin: '0.4rem auto 0', fontSize: '0.92rem' }}>
            Registration Fee: <strong>NPR 1,000</strong>. Payable directly to Marriage Consultant <strong>Laxmikant Timilsina</strong>.
          </p>
        </div>

        {/* QR Payment Box */}
        <div className="card" style={{ textAlign: 'center', border: '1.5px solid #D4AF37', marginBottom: '2.5rem' }}>
          <span className="badge" style={{ marginBottom: '0.8rem' }}>
            📲 eSewa & Fonepay QR Payment
          </span>
          <h2 style={{ fontSize: '1.8rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.3rem', fontFamily: 'var(--serif)' }}>
            Pay Registration Fee (NPR 1,000)
          </h2>
          <div style={{ fontSize: '1.4rem', fontWeight: 900, color: '#8C6A23', marginBottom: '1rem' }}>
            Pay to Laxmikant Timilsina — 9857074103
          </div>

          {/* QR Box Visual */}
          <div style={{
            maxWidth: '240px',
            margin: '0 auto 1.5rem',
            background: '#fff',
            border: '2px solid #D4AF37',
            borderRadius: '20px',
            padding: '1.5rem',
            boxShadow: '0 8px 30px rgba(212,175,55,0.15)'
          }}>
            <div style={{ fontSize: '4rem', marginBottom: '0.5rem' }}>📱💳</div>
            <div style={{ fontSize: '0.8rem', fontWeight: 800, color: '#9E1B32' }}>
              NPR 1,000 Registration
            </div>
            <div style={{ fontSize: '0.74rem', color: '#6E615E' }}>
              eSewa / Fonepay: 9857074103
            </div>
          </div>

          <div style={{ background: '#FFF3E0', color: '#E65100', padding: '0.8rem 1.2rem', borderRadius: '14px', fontSize: '0.86rem', fontWeight: 700, maxWidth: '600px', margin: '0 auto 1.5rem' }}>
            ⚠️ Important: After completing payment of NPR 1,000, send your transaction screenshot via WhatsApp to 9857074103 for profile verification.
          </div>

          <a href="https://wa.me/9779857074103" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
            💬 WhatsApp Screenshot to 9857074103 →
          </a>
        </div>

        {/* Transaction ID Submission Form */}
        <div className="card">
          <h3 style={{ fontSize: '1.4rem', fontWeight: 700, color: '#9E1B32', marginBottom: '0.6rem', fontFamily: 'var(--serif)' }}>
            Submit Transaction ID (Optional)
          </h3>
          <p style={{ fontSize: '0.86rem', color: '#6E615E', marginBottom: '1.2rem' }}>
            Submit your transaction reference number below for instant record tracking.
          </p>

          {submitted ? (
            <div style={{ background: '#e8f5e9', color: '#2e7d32', padding: '1rem', borderRadius: '14px', textAlign: 'center', fontWeight: 700 }}>
              ✓ Transaction ID submitted! Consultant Laxmikant Timilsina will verify your account shortly.
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '1.2rem' }}>
                <label style={{ display: 'block', fontSize: '0.78rem', fontWeight: 700, color: '#1C1014', marginBottom: '0.4rem', textTransform: 'uppercase' }}>
                  eSewa / Fonepay Transaction ID:
                </label>
                <input
                  type="text"
                  className="form-input"
                  placeholder="e.g. TXN-98471038"
                  value={txId}
                  onChange={(e) => setTxId(e.target.value)}
                  required
                />
              </div>
              <button className="btn btn-primary btn-full" type="submit">
                Submit Transaction ID →
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
